
Promise.all([
  import('../../plugins/semantic/form'),
  import('../../plugins/semantic/form.scss'),
  // import('../../plugins/jquery-address/jquery.address'),
]).then(() => {
  Promise.all([
    import('./gdpr.scss'),
    import('../../scripts/dbs/dbs.semantic.form'),
    import('../../scripts/dbs/dbs.utilities.querystring'),
    import('../../plugins/semantic/tab.css'),
    import('../../plugins/semantic/label.css'),
    import('../../plugins/semantic/tab'),
    import('../../plugins/semantic/dropdown'),
    import('../../plugins/semantic/dropdown.scss'),
    import('../../plugins/semantic/icon.css'),
    import('../../plugins/semantic/flag.css'),
    import('../../plugins/semantic/transition.css'),
    import('../../plugins/semantic/transition'),
    import('../../plugins/semantic/api'),
    import('../../plugins/semantic/checkbox.css'),
    import('../../plugins/semantic/checkbox'),
    import('../../plugins/semantic/modal'),
    import('../../plugins/semantic/modal.scss'),
  ]).then(() => {
    const widget = $('.widget.sw-gdpr')

    // If widget not found, mark GDPR as disabled

    const qs = new dbs.utilities.querystring();
    const alwaysShowGDPR = !!qs.getParameter('alwaysShowGDPR');

    if (localStorage.getItem('gdprConsentAccepted') == null || alwaysShowGDPR) { // Show if we don't have a local storage key
      widget.each(function (i, el) {
        if (i > 0) return $(el).remove() // remove duplicate GDPR widgets
        $(el).data('widget', new Gdpr(el, i))
        $(el).data('widget').init()
      })
    } else {
      window.dbs.globalEvents.emit('gdprAccepted', true); // GDPR is already accepted, this triggers the subscription popup in that case
    }
  })
})

function Gdpr(el, index) {
  const self = this
  self.el = $(el)
  self.uid = `Gdpr_${index}`

  self.qs = new dbs.utilities.querystring();
  const alwaysShowGDPR = !!self.qs.getParameter('alwaysShowGDPR');

  self.dataGdprEndpoint = self.el.attr('data-gdpr-endpoint')
  if (alwaysShowGDPR) self.dataGdprEndpoint = self.dataGdprEndpoint + '?alwaysShow=true'

  self.dataGdprEndpointMethod = self.el.attr('data-gdpr-endpoint-method')
  self.dataSetGdprEndpoint = self.el.attr('data-set-gdpr-endpoint')
  self.dataSetGdprEndpointMethod = self.el.attr('data-set-gdpr-endpoint-method')

  self.staticConsentModal = self.el.find('.sw-gdpr-static-consent')
  self.staticConsentForm = new dbs.form.genericForm()
  self.staticConsentForm.init(self.el.find('.sw-gdpr-static-consent .ui.form'))

  self.privacyPreferenceModal = self.el.find('.sw-privacy-popup')
  self.privacyPreferenceForm = new dbs.form.genericForm()
  self.privacyPreferenceForm.init($('.sw-privacy-popup .ui.form'))

  self.localstorageKeyName = 'gdprConsentAccepted';

  self.initStaticConsentModal = function () {

    if (!window.dbs.utilities.getLocalStorageWithExpiry(self.localstorageKeyName)) {
      self.staticConsentModal
        .modal({
          useFlex: true, // ensures predicable layout styling overrides
          closable: false,
          transition: 'fade up', // See: https://semantic-ui.com/modules/transition.html#/examples
          duration: 900,
          onHidden: () => window.dbs.globalEvents.emit('shepherdDone', self.uid),
        })
        .modal('show')
    } else {
      window.dbs.globalEvents.emit('gdprAccepted', true); // GDPR is already accepted, this triggers the subscription popup in that case
    }
  }



  self.initPrivacyPreferenceModal = function () {
    self.privacyPreferenceForm.el.find('.ui.checkbox').checkbox()

    self.staticConsentModal.modal({
      onHidden: () => { }, // clear 'shepherdDone' from the previous modal.
      duration: 200,
      transition: 'fade',
    }) // do not 'hide' this modal, it transitions between with next modal 'show'

    self.privacyPreferenceModal
      .modal({
        closable: false,
        onHidden: () => window.dbs.globalEvents.emit('shepherdDone', self.uid),
      })
      .modal('show')
  }

  self.setGdprConsentAccepted = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('setGdprConsentAccepted')
    }
    window.dbs.globalEvents.emit('gdprAccepted', true);
    self.privacyPreferenceModal.modal('hide')
    self.staticConsentModal.modal('hide')

    window.dbs.utilities.setLocalStorageWithExpiry(self.localstorageKeyName, true, 365);
  }

  self.selectAllPreferences = function (form) {
    const checkboxes = $(form).find('input[type="checkbox"][name="preference[]"')
    checkboxes.each((k, el) => $(el).prop('checked', true))
  }

  self.getSelectedPreferences = function (form) {
    let preferences = []
    $(form)
      .find('input[type="checkbox"][name="preference[]"')
      .each(function (k, el) {
        let checkbox = $(el)
        if (checkbox.is(':checked')) {
          preferences.push(checkbox.attr('value'))
        }
      })

    return { preference: preferences } // e.g. `{ "preference": ["Essential", "Performance"] }`
  }

  self.getGdpr = function () {
    // This used to call and determine if it should show, we're just going to show it always now.
    self.initStaticConsentModal()
  }

  self.setGdpr = function (form) {
    const data = self.getSelectedPreferences(form)

    if (process.env.NODE_ENV === 'development') {
      console.log('Set GDPR:', data)
    }

    form.find('.submit.button').addClass('loading').blur()
    self.setGdprConsentAccepted()
    form.find('.submit.button').removeClass('loading').blur()
    $.ajax({
      url: self.dataSetGdprEndpoint,
      type: self.dataSetGdprEndpointMethod,
      contentType: 'application/json',
      data: JSON.stringify(data),
    })
      .done(function (response) {
        if (response.Success) {
          //return self.setGdprConsentAccepted()
          return;
        }

        if (process.env.NODE_ENV === 'development') {
          console.error('GDPR set preferences was not successful, please try again.')
        }
      })
      .always(function () {
        form.find('.submit.button').removeClass('loading').blur()
      })
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('Gdpr init', self)
    }

    // This has no effect as we are showing the GDPR content with semantic-ui modals
    // which have the DOM elements moved to the bottom of the <body>
    self.el.css('opacity', 1)

    window.dbs.globalEvents.subscribe('shepherdNext', function (item) {
      if (item !== self.uid) return
      console.log('[SHEPHERD][popup]', item === self.uid, item)

      self.getGdpr()
    })

    $('.edit-preference').click(function (e) {
      e.preventDefault()
      self.initPrivacyPreferenceModal()
    })

    self.staticConsentForm.submitButton.on('click', function (e) {
      e.preventDefault()
      const staticConsentForm = self.staticConsentForm.el

      if ($(this).hasClass('select-all-preferences')) {
        self.selectAllPreferences(staticConsentForm)
      }

      self.setGdpr(staticConsentForm)
      return false // prevent form action
    })

    self.privacyPreferenceForm.submitButton.on('click', function (e) {
      e.preventDefault()
      const privacyPreferenceForm = self.privacyPreferenceForm.el

      if ($(this).hasClass('select-all-preferences')) {
        self.selectAllPreferences(privacyPreferenceForm)
      }

      self.setGdpr(privacyPreferenceForm)
      return false // prevent form action
    })

    window.dbs.globalEvents.emit('shepherdQueue', self.uid)
  }
}
